export default __webpack_public_path__ + "static/media/527.50bdcade.png";